import { Menu } from 'features/MenuList/models/menu';
import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { MenuDetailView } from './models/menuDetail';

const menuDetailService = {
  getMenu(data: { menu_id: number; expired_date: string }): Promise<CommonResponse<Menu>> {
    const url = `/get-menu?id=${data.menu_id}&expired_date=${data.expired_date}`;
    return axiosClient.get(url);
  },
  patchMenu(data: Menu): Promise<CommonResponse<null>> {
    const url = `/update-menu`;
    return axiosClient.patch(url, data);
  },
  patchSubMenu(data: Menu): Promise<CommonResponse<null>> {
    const url = `/update-sub-menu`;
    return axiosClient.patch(url, data);
  },
  getMenuDetails(data: { menu_id: number; expired_date: string }): Promise<CommonResponse<MenuDetailView[]>> {
    const url = `/get-list-of-menu-detail?id=${data.menu_id}&expired_date=${data.expired_date}`;
    return axiosClient.get(url);
  },
};

export default menuDetailService;
